import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { setCookieLanguage } from '~/utils/cookie'

Vue.use(VueI18n)

export default ({ app, route }) => {
  const lang = route.query.lang

  if (lang) {
    setCookieLanguage(app.$cookie, lang)
  }

  const cookieLocale = app.$cookie.get('locale')
  let locale = cookieLocale || 'en'

  if (!cookieLocale) {
    setCookieLanguage(app.$cookie, locale)
  }

  if (app.$moment && typeof app.$moment.locale === 'function') {
    switch (locale) {
      case 'ind':
        locale = 'id'
        app.$moment.locale('id')
        break
      case 'vie':
        locale = 'vi'
        app.$moment.locale('vi')
        break
      case 'zh':
      case 'chn':
        locale = 'zh'
        app.$moment.locale('zh-cn')
        break
      default:
        app.$moment.locale('en')
        break
    }
  }

  app.i18n = new VueI18n({
    locale,
    fallbackLocale: 'en',
    messages: {
      en: require('~/locale/en.json'),
      vi: require('~/locale/vi.json'),
      zh: require('~/locale/zh_CN.json'),
      th: require('~/locale/th.json'),
      ms: require('~/locale/ms.json'),
      id: require('~/locale/id.json'),
    },
  })

  app.mounted = () => {
    document.querySelector('html').setAttribute('lang', locale)
  }
}
